<div
  class="size-container text-center rounded-circle cursor-pointer h1-font-size"
>
  <span class="text-value">{{ text }}</span>
</div>
